import React from "react";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { InputNoticeList } from "./input-notice-list";
import { SimpleTextInput } from "./simple-text-input";
import type { InputProps, PathProps } from "./types";

const notices = [
  "電子申請を行う際に必要な費用について記述します。記述がない場合、無料であるとみなされます。",
  "例: 1件につき 200円(令和5年4月以降は300円)",
  // TODO: 文字数制限
];

type Props = InputProps & PathProps & { value?: string; errorMsg?: string };

export const ProcedureOnlineInfoFeeInput: React.FC<Props> = ({
  onChange,
  disabled = false,
  basePath,
  value,
  shouldDisplayError = false,
  errorMsg,
}) => {
  return (
    <div className="field mb-6">
      <FormFieldLabel label="電子申請手数料" />
      <InputNoticeList notices={notices} />
      <SimpleTextInput
        onChange={onChange}
        basePath={basePath}
        value={value}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={errorMsg}
      />
    </div>
  );
};
